"use client"

import { useMemo } from "react";
import { SankeyChart } from "./charts/sankey-chart";
import { useSankeyData } from "@/hooks/useQueryResults";

export function TransactionsSankey({id, pivot}: {id: number, pivot: string}) {
    const formatter = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"})
    const { results } = useSankeyData({id, pivot})

    const [totalIn, totalOut] = useMemo(() => {
        if (!results || !results.links) {
            console.log(`no results for ${id}`)
            return [0, 0]
        }
        return results.links.reduce(([tIn, tOut], link) => {
            if (link.target == pivot) {
                return [tIn + link.value, tOut]
            } else if (link.source == pivot) {
                return [tIn, tOut + link.value]
            }
            return [tIn, tOut]
        }, [0, 0])
    }, [results, pivot])

    return <div className="h-[40vh]">
        <SankeyChart
            data={results}
            title={`${pivot} Transfers`}
            tooltip={{
                seriesValueFormatter: (v) => formatter.format(v)
            }}
        />
        <div className="grid w-full grid-cols-3 text-center">
            <div>
            <h1>total in</h1>
            <h1 className="text-green">{formatter.format(totalIn)}</h1>
            </div>
            <div>
            <h1>total out</h1>
            <h1 className="text-red">{formatter.format(totalOut)}</h1>
            </div>
        </div>
    </div>
}

export function CoreCouncilTransactions() {
    return <TransactionsSankey id={7507144} pivot="Core Council" />
}

export function SffTransactions() {
    return <TransactionsSankey id={7444703} pivot="Sky Frontier Foundation" />
}

export function SparkTransactions() {
    return <TransactionsSankey id={7646158} pivot="Spark Proxy" />
}
